import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import vindrApi from "../utils/vindrapi";
import schemas from "../data/dataSchemas";
import Select from "react-select";

//
//{
//
//    "name":"Latesto O\u00dc",
//    "airtableId":"rec4iQSTveeQTJnJD",
//    "email":"rein.palipea@latesto.ee",
//    "phone":"+3725045647",
//    "address":", ",
//    "id":233,
//    "properties":[
//        {
//            "id":"13402:002:0400",
//            "status":"Ready to sign"
//        }
//    ],
//    "totalArea":6.44
//
//}


const { Formik } = formik;

class DialogProject extends React.Component {
	

	
	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''}
		}
		
		//this.owner = schemas.owner.cast(this.props.owner);
		this.projectCountries = [
			{label:"Norway",	value:"norway"},
			{label:"Sweden",	value:"sweden"},
			{label:"Estonia",	value:"estonia"},
			{label:"Latvia",	value:"latvia"}
		];
		
		this.energyTypes = [
			{label:"Wind",		value:"wind"},
			{label:"Solar",		value:"solar"},
			{label:"Battery",	value:"battery"}
		];

	}
	updateStatus(s){
		var x = {...this.state};
		x.status = s;
		this.setState(x);
		this.forceUpdate();
	}


	handleClose(data){
		this.props.onClose(data);
		this.updateStatus({sent:null, message:''});
	};
	handleOnShow(e){
		
		
		if(!this.props.user.userDetails)
			this.updateStatus({sent:true, success:false, message:'Login required'});
		this.forceUpdate();
	};

	handleSubmit(data){
		
		this.updateStatus({sent:false, success:false, message:'Saving...'});

		var projectToPost = (({name, country, energyTypes}) => ({ name, country, energyTypes}))(data);
		projectToPost = {...projectToPost, boundary: this.props.state.boundary, username:this.props.user.userDetails};
		

		vindrApi.createProject(projectToPost).then((data)=>{
			if(data.projectid){
				this.updateStatus({sent:true, success:true, message:'Project has been created'});
				setTimeout(() => {
					window.location.href = '/pages/project/'+data.projectid;
				}, 2000);
			}
			else
				this.updateStatus({sent:true, success:false, message:'Error saving Project'});
		}).catch((e)=>{
			this.updateStatus({sent:true, success:false, message:'Error saving Project'});
		});
	};


	render() {
		return (
			<Modal show={!!this.props.state.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>New Project</Modal.Title>
				</Modal.Header>

				<Formik validationSchema={schemas.project} onSubmit={this.handleSubmit.bind(this)} initialValues={{}}>	
					{({ handleSubmit, handleChange, values, touched, errors, control, setFieldValue }) => (
						
						<Form noValidate onSubmit={handleSubmit}>
							<input type="hidden" name="id" value={values.id} />
							{this.state.status.sent === null ? (
								<React.Fragment>
									<Modal.Body>
										<Row className="mb-3">
											<Form.Group as={Col} md="6" controlId="validationFormik01">
												<Form.Label>Project Name</Form.Label>
												<Form.Control type="text" name="name" placeholder="Project Name" value={values.name } onChange={handleChange} isValid={touched.name && !errors.name} isInvalid={errors.name}/>
												<Form.Control.Feedback type="invalid">
													Please provide a valid name.
												</Form.Control.Feedback>
											</Form.Group>
											<Form.Group as={Col} md="6" controlId="validationFormik00">
												<Form.Label>Country</Form.Label>
												<Select name="country" options={this.projectCountries} onChange={(sel)=>setFieldValue("country", sel.value)}  isSearchable={false} placeholder="Country" isValid={touched.country && !errors.country} isInvalid={errors.country}
													styles={{
													control: (baseStyles, state) => ({...baseStyles, borderColor: errors.country ? 'var(--bs-form-invalid-border-color)' : 'var(--bs-border-color)',
													}),
												  }}
												/>
												{touched.country && errors.country ? (
												<Form.Control.Feedback type="invalid" className="d-block">
													Please select an country.
												</Form.Control.Feedback>
												) : (<span></span>)}
											</Form.Group>
										</Row>
										<Row className="mb-3">
											<Form.Group as={Col} md="12" controlId="validationFormik03">
												<Form.Label>Energy type(s)</Form.Label>
												<Select name="energyTypes" options={this.energyTypes} onChange={(sel)=>{setFieldValue("energyTypes",[sel.value])}} isSearchable={false} placeholder="Energy types"
													styles={{
													control: (baseStyles, state) => ({...baseStyles, borderColor: errors.energyTypes ? 'var(--bs-form-invalid-border-color)' : 'var(--bs-border-color)',
													}),
												  }}
												/>
												{touched.energyTypes && errors.energyTypes ? (
												<Form.Control.Feedback type="invalid" className="d-block">
													Please select an energy type.
												</Form.Control.Feedback>
												) : (<span></span>)}
												
											</Form.Group>
										</Row>
										
									</Modal.Body>
									<Modal.Footer>
										<Button className="me-auto" variant="secondary" onClick={(e)=>this.handleClose()}>Close</Button>
										<Button variant="success" type="submit">Save Project</Button>
									</Modal.Footer>
								</React.Fragment>
							) : (
							<Modal.Body>
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							</Modal.Body>	
							)}
						</Form>
					)}	
				</Formik>
			</Modal>
		);
	}
}

export default DialogProject;